function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 97.882,
  y: 135.529,
  width: 15.059,
  height: 15.059
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 120.471,
  y: 135.529,
  width: 15.059,
  height: 15.059
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 143.059,
  y: 135.529,
  width: 15.059,
  height: 15.059
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 165.647,
  y: 135.529,
  width: 15.059,
  height: 15.059
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 188.235,
  y: 135.529,
  width: 15.059,
  height: 15.059
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 210.824,
  y: 135.529,
  width: 15.059,
  height: 15.059
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 233.412,
  y: 135.529,
  width: 15.059,
  height: 15.059
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 256,
  y: 135.529,
  width: 15.059,
  height: 15.059
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 278.588,
  y: 135.529,
  width: 15.059,
  height: 15.059
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 301.176,
  y: 135.529,
  width: 15.059,
  height: 15.059
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 97.882,
  y: 436.706,
  width: 15.059,
  height: 15.059
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 120.471,
  y: 436.706,
  width: 15.059,
  height: 15.059
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 143.059,
  y: 436.706,
  width: 15.059,
  height: 15.059
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 165.647,
  y: 436.706,
  width: 15.059,
  height: 15.059
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 188.235,
  y: 436.706,
  width: 15.059,
  height: 15.059
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 210.824,
  y: 436.706,
  width: 15.059,
  height: 15.059
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 233.412,
  y: 436.706,
  width: 15.059,
  height: 15.059
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  x: 256,
  y: 436.706,
  width: 15.059,
  height: 15.059
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 278.588,
  y: 436.706,
  width: 15.059,
  height: 15.059
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 301.176,
  y: 436.706,
  width: 15.059,
  height: 15.059
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M331.294,87.234v-11.94h7.529V60.235h-7.529V0H82.824v60.235h-7.529v15.059h7.529v11.94l-15.059,15.059v372.06 c0,20.758,16.888,37.647,37.647,37.647h203.294c20.759,0,37.647-16.889,37.647-37.647v-372.06L331.294,87.234z M308.706,15.059 h7.529v45.176h-7.529V15.059z M278.588,15.059h15.059v45.176h-15.059V15.059z M240.941,15.059h22.588v45.176h-22.588V15.059z  M188.235,15.059h37.647v45.176h-37.647V15.059z M150.588,15.059h22.588v45.176h-22.588V15.059z M120.471,15.059h15.059v45.176 h-15.059V15.059z M97.882,15.059h7.529v45.176h-7.529V15.059z M82.824,108.531l10.649-10.649h79.704V82.824H97.882v-7.529h218.353 v18.178l15.059,15.059v4.41H82.824V108.531z M82.824,135.529V128h248.471v7.529h-7.529v15.059h7.529v286.118h-7.529v15.059h7.529 v7.529H82.824v-7.529h7.529v-15.059h-7.529V150.588h7.529v-15.059H82.824z M308.706,496.941H105.412 c-12.455,0-22.588-10.134-22.588-22.588h248.471C331.294,486.808,321.161,496.941,308.706,496.941z"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  x: 188.235,
  y: 82.824,
  width: 30.118,
  height: 15.059
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  x: 233.412,
  y: 82.824,
  width: 15.059,
  height: 15.059
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M301.176,293.647c0-49.362-38.198-89.967-86.588-93.816v-30.419h-15.059v30.419c-48.39,3.849-86.588,44.454-86.588,93.816 c0,46.393,34.112,85.973,79.693,92.992c4.012,6.469,7.012,11.083,8.128,12.784l6.296,9.6l6.296-9.6 c1.114-1.699,4.109-6.304,8.114-12.76C267.198,379.666,301.176,340.403,301.176,293.647z M128,293.647 c0-41.053,31.456-74.887,71.529-78.691v22.738c-27.589,3.694-48.941,27.37-48.941,55.954c0,17.441,16.918,50.293,31.199,74.919 C150.276,357.929,128,328.012,128,293.647z M207.059,381.299c-15.536-24.892-41.412-70.042-41.412-87.652 c0-20.262,14.632-37.161,33.882-40.713v47.006l-17.56,17.56l10.649,10.648l6.911-6.911v25.117h15.059v-53.351l5.969,5.969 l10.649-10.648l-16.619-16.619v-18.77c19.25,3.553,33.882,20.451,33.882,40.713C248.471,311.258,222.595,356.407,207.059,381.299z  M232.316,368.591c14.284-24.628,31.213-57.497,31.213-74.944c0-28.584-21.352-52.259-48.941-55.954v-22.738 c40.074,3.805,71.529,37.638,71.529,78.691C286.118,328.29,263.909,358.023,232.316,368.591z"
});

var _ref26 = /*#__PURE__*/React.createElement("rect", {
  x: 90.353,
  y: 165.647,
  width: 15.059,
  height: 15.059
});

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  x: 135.529,
  y: 165.647,
  width: 15.059,
  height: 15.059
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M425.412,512h-37.647c-10.38,0-18.824-8.444-18.824-18.823c0-10.38,8.444-18.824,18.824-18.824h37.647 c10.38,0,18.824,8.444,18.824,18.824C444.235,503.556,435.791,512,425.412,512z M387.765,489.412c-2.075,0-3.765,1.689-3.765,3.765 c0,2.076,1.69,3.765,3.765,3.765h37.647c2.075,0,3.765-1.689,3.765-3.765c0-2.076-1.69-3.765-3.765-3.765H387.765z"
});

var _ref29 = /*#__PURE__*/React.createElement("g", null);

var _ref30 = /*#__PURE__*/React.createElement("g", null);

var _ref31 = /*#__PURE__*/React.createElement("g", null);

var _ref32 = /*#__PURE__*/React.createElement("g", null);

var _ref33 = /*#__PURE__*/React.createElement("g", null);

var _ref34 = /*#__PURE__*/React.createElement("g", null);

var _ref35 = /*#__PURE__*/React.createElement("g", null);

var _ref36 = /*#__PURE__*/React.createElement("g", null);

var _ref37 = /*#__PURE__*/React.createElement("g", null);

var _ref38 = /*#__PURE__*/React.createElement("g", null);

var _ref39 = /*#__PURE__*/React.createElement("g", null);

var _ref40 = /*#__PURE__*/React.createElement("g", null);

var _ref41 = /*#__PURE__*/React.createElement("g", null);

var _ref42 = /*#__PURE__*/React.createElement("g", null);

var _ref43 = /*#__PURE__*/React.createElement("g", null);

var SvgFeeding = function SvgFeeding(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69E041"
    },
    d: "M425.412,504.471h-37.647c-6.237,0-11.294-5.057-11.294-11.294l0,0 c0-6.237,5.057-11.294,11.294-11.294h37.647c6.237,0,11.294,5.057,11.294,11.294l0,0 C436.706,499.414,431.649,504.471,425.412,504.471z"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#F9A12B"
    },
    points: "90.353,67.765 90.353,7.529 323.765,7.529 323.765,67.765 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.294,
    y: 120.471,
    style: {
      fill: "#FFFFFF"
    },
    width: 263.529,
    height: 346.353
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 112.941,
    y: 9.412,
    style: {
      fill: "#FBC377"
    },
    width: 30.118,
    height: 60.235
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.059,
    y: 9.412,
    style: {
      fill: "#FBC377"
    },
    width: 30.118,
    height: 60.235
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.706,
    y: 9.412,
    style: {
      fill: "#FBC377"
    },
    width: 52.706,
    height: 60.235
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBC377"
    },
    d: "M195.766,379.505c-42.486-5.534-75.295-41.865-75.295-85.858c0-47.822,38.766-86.588,86.588-86.588 s86.588,38.766,86.588,86.588c0,44.641-33.782,81.392-77.176,86.082"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 75.294,
    y: 122.348,
    style: {
      fill: "#F9A12B"
    },
    width: 261.642,
    height: 20.706
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCEA5C"
    },
    d: "M256,293.647c0,27.03-48.941,101.647-48.941,101.647s-48.941-74.617-48.941-101.647 c0-27.03,21.912-48.941,48.941-48.941S256,266.617,256,293.647z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.294,
    y: 444.235,
    style: {
      fill: "#F9A12B"
    },
    width: 261.642,
    height: 20.706
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#69E041"
    },
    points: "75.294,120.471 75.294,105.412 90.353,90.353 90.353,65.882 323.765,65.882 323.765,90.353  338.824,105.412 338.824,120.471 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.353,
    y: 65.877,
    style: {
      fill: "#4FA831"
    },
    width: 233.412,
    height: 24.471
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69E041"
    },
    d: "M75.294,474.353L75.294,474.353c0,16.634,13.484,30.118,30.118,30.118h203.294 c16.634,0,30.118-13.484,30.118-30.118l0,0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.176,
    y: 468.701,
    style: {
      fill: "#4FA831"
    },
    width: 261.642,
    height: 16.941
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, /*#__PURE__*/React.createElement("rect", {
    x: 199.529,
    y: 30.118,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.059,
    height: 15.059
  }), _ref25, _ref26, /*#__PURE__*/React.createElement("rect", {
    x: 112.941,
    y: 165.647,
    style: {
      fill: "#DCEA5C"
    },
    width: 15.059,
    height: 15.059
  }), _ref27, /*#__PURE__*/React.createElement("rect", {
    x: 271.059,
    y: 165.647,
    style: {
      fill: "#DCEA5C"
    },
    width: 52.706,
    height: 15.059
  }), _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFeeding, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/feeding.e98cb894.svg";
export { ForwardRef as ReactComponent };